import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const TreeRowStyled = styled.div`

`;

const TreeLinkStyled = styled.div`
	display: flex;
	padding-left: ${props => props.level ? props.level * 5 : 0}px;

	&:hover {
		background: var(--bs-gray-300);
		cursor: pointer;
	}

	&.selected {
		color: var(--bs-primary);
	}

	.btn-dropdown-content {
		display: inline-flex;
		align-items: start;
		min-width: 20px;

		button {
			background: none;
			height: auto;
			min-height: auto;
			padding: 0;
			border: 0;
			width: 100%;
		}
	}

	.icon {
		display: inline-flex;
		min-width: 20px;
		margin-left: 5px;

		i.bi-folder-fill {
			color: var(--bs-orange);
		}
	}
		
	.name {
		display: inline-flex;
		user-select: none;
		padding: 4px 0px;
		line-height: 15px;
	}
`;

const TreeContentStyled = styled.div`

`;

let axiosCancelToken = null;

export default function TreeRow(props) {
    let community = props.community;
    let folder = props.folder;
    let level = props.level;
    let selectedFolderId = props.selectedFolderId;
    let openFolder = props.openFolder;
    let reload = props.reload;
    
    let [opened, setOpened] = useState(props.folder?.id === -1 ? true : false);
    let [tree, setTree] = useState([]);

    // FIX: If communities folder and community selected
    // Solo remapear si la comunidad tiene carpeta documental (folder_id). Si es nulo
    // (comunidad sin carpeta creada) NO se remapea: evitaba dejar id=null, que hacía
    // que get-folder-tree devolviese la raíz una y otra vez (recursión infinita).
    if ( community?.folder_id && (folder.code === 'communities' || folder.id === community.folder_id) ) {
        folder.name = 'Documentos comunidad';
        folder.id = community.folder_id;
        folder.has_content = true;
    }

    useEffect(() => {
        axiosCancelToken = axios.CancelToken.source();
    
        return function cleanup() {
            axiosCancelToken.cancel();
        }
    }, []);

    useEffect(() => {
        if ( !opened || !folder.has_content ) {
            return;
        }

        // Load subfolders
		const getFolderTree = async () => {
            axiosCancelToken = axios.CancelToken.source(); // Fix: need to regenerate if not, cant open for second time

			await axios.get('/api/manager/documents/get-folder-tree', {
				params: {
                    folder_id: folder.id !== -1 ? folder.id : null,
					community_id: community?.id
				},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
				setTree([...response.data]);
		  	}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});	
		}
		getFolderTree();
	}, [reload, community, opened, folder.id, folder.has_content]);

    const dropdownClick = (e, status, open = false) => {
		if ( e ) e.stopPropagation();

        setOpened(status);
        if ( open ) openFolder(folder);
        if ( !status ) setTree([]);
	}

    return (
        <TreeRowStyled>
            <TreeLinkStyled className={selectedFolderId === folder.id ? 'selected' : ''} level={level} onClick={(e) => dropdownClick(e, true, true)}>
                <div className="btn-dropdown-content">
                    { folder.has_content &&
                        <React.Fragment>
                            { !opened ?
                                <button onClick={(e) => dropdownClick(e, true)}><i className="bi bi-caret-right"></i></button>
                                :
                                <button onClick={(e) => dropdownClick(e, false)}><i className="bi bi-caret-down"></i></button>
                            }
                        </React.Fragment>
                    }
                </div>
                <div className="icon">
                    <i className="bi bi-folder-fill"></i>
                </div>
                <div className="name">{folder.name}</div>
            </TreeLinkStyled>

            
            <TreeContentStyled>
                { (opened && tree.length > 0) && 
                    tree.map((el, idx) => {
                        return (
                            <TreeRow 
                                key={idx}

                                folder={el}
                                openFolder={openFolder}
                                selectedFolderId={selectedFolderId}
                                community={community}
                                reload={reload}
                                level={level+1}
                            />
                        )
                    })
                }
            </TreeContentStyled>
        </TreeRowStyled>
    );
}